$(document).ready(function () {
    let events_tables = $(".events-table");

    events_tables.each(function () {
        let when = $(this).attr("data-when");

        $(this).bootstrapTable({
            url: "/api/events?when=" + when,
            columns: [{field: 'id', visible: false}, {field: 'time', align: 'center'}, {field: 'title'}],
            idField: 'id',
            autoRefresh: true,
            showHeader: false,
            onClickRow: function (row) {
                window.location = '/event/' + row.id;
            },
            formatLoadingMessage: function () {
                return localisation.wait_ongoing_loading
            },
            formatNoMatches: function () {
                return localisation.nothing_found
            },
            rowAttributes: function (row) {
                return {role: 'button', 'data-event-id': row.id}
            }
        })
    })
})
